import { atom } from 'recoil';

export const sidebarState = atom({
  key: 'sidebarState',
  default: {
    show: false,
    onClose: null,
    actionButton: null,
    backdropLink: null,
    title: null,
    subHeader: null,
    body: null,
    footer: null,
    placement: 'right',
    width: '72',
  },
  effects_UNSTABLE: [
    ({ onSet }) => {
      onSet((newSidebar) => {
        if (typeof window !== 'undefined' && window.zE) {
          if (newSidebar.show && window.zE.hide && window.zE.show) {
            if (typeof window.zE.hide === 'function') window.zE.hide();
          } else if (typeof window.zE.show === 'function') window.zE.show();
        }
      });
    },
  ],
});
